import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getProductBoardToken } from '../user.service';

interface UseGetProductBoardTokenResult {
  data: string;
}

const useGetProductBoardToken = (): UseQueryResult<UseGetProductBoardTokenResult, Error> => {
  return useQuery<UseGetProductBoardTokenResult, Error>({
    queryKey: ['productBoardToken'],
    queryFn: async () => {
      const response = await getProductBoardToken();
      return { data: response.data };
    },
  });
};

export default useGetProductBoardToken;
